import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.cusat.title',
    defaultMessage: 'CuSat Data',
  },
  manageCusatData: {
    id: 'pages.cusat.manageCusatData',
    defaultMessage: 'Manage CuSat Data',
  },
  accountName: {
    id: 'pages.cusat.accountName',
    defaultMessage: 'Account name',
  },
  industryExpertise: {
    id: 'pages.cusat.industryExpertise',
    defaultMessage: 'Industry & services expertise',
  },
  goalsAlignment: {
    id: 'pages.cusat.goalsAlignment',
    defaultMessage: 'Endgame thinking',
  },
  communication: {
    id: 'pages.cusat.communication',
    defaultMessage: 'Communication',
  },
  proactiveApproach: {
    id: 'pages.cusat.proactiveApproach',
    defaultMessage: 'Empathetic challenger',
  },
  projectLeadership: {
    id: 'pages.cusat.projectLeadership',
    defaultMessage: 'Project leadership',
  },
  executionQuality: {
    id: 'pages.cusat.executionQuality',
    defaultMessage: 'Execution quality',
  },
  projectDeliverables: {
    id: 'pages.cusat.projectDeliverables',
    defaultMessage: 'Project deliverables',
  },
  stakeholdersFeedback: {
    id: 'pages.cusat.stakeholdersFeedback',
    defaultMessage: 'Stakeholders feedback',
  },
  lastUpdatedAt: {
    id: 'pages.cusat.lastUpdatedAt',
    defaultMessage: 'Last updated',
  },
  actions: {
    id: 'pages.cusat.actions',
    defaultMessage: 'Actions',
  },
  searchByAccount: {
    id: 'pages.cusat.searchByAccount',
    defaultMessage: 'Search by account name',
  },
  updatedFrom: {
    id: 'pages.cusat.updatedFrom',
    defaultMessage: 'Updated from',
  },
  updatedTo: {
    id: 'pages.cusat.updatedTo',
    defaultMessage: 'Updated to',
  },
  addAccount: {
    id: 'pages.cusat.addAccount',
    defaultMessage: 'Add account',
  },
  editAccount: {
    id: 'pages.cusat.editAccount',
    defaultMessage: 'Edit CuSat data',
  },
  deleteAccountTitle: {
    id: 'pages.cusat.deleteAccountTitle',
    defaultMessage: 'Delete CuSat data',
  },
  deleteAccountText: {
    id: 'pages.cusat.deleteAccountText',
    defaultMessage:
      'Are you sure you want to delete the CuSat data for {accountName}? Scorecards that already use this account keep their copied scores.',
  },
  accountCreated: {
    id: 'pages.cusat.accountCreated',
    defaultMessage: 'CuSat data for {accountName} has been added',
  },
  accountUpdated: {
    id: 'pages.cusat.accountUpdated',
    defaultMessage: 'CuSat data for {accountName} has been updated',
  },
  accountDeleted: {
    id: 'pages.cusat.accountDeleted',
    defaultMessage: 'CuSat data for {accountName} has been deleted',
  },
  accountNameTaken: {
    id: 'pages.cusat.accountNameTaken',
    defaultMessage: 'An account with this name already exists',
  },
  scoreHint: {
    id: 'pages.cusat.scoreHint',
    defaultMessage: 'Score from 1 to 5, up to two decimal places',
  },
  errorScoreRange: {
    id: 'pages.cusat.errorScoreRange',
    defaultMessage: 'Enter a score from 1 to 5 with at most two decimal places',
  },
  feedbackPlaceholder: {
    id: 'pages.cusat.feedbackPlaceholder',
    defaultMessage: 'Add stakeholders feedback',
  },
  errorAccountNameLength: {
    id: 'pages.cusat.errorAccountNameLength',
    defaultMessage: 'Account name must be {max} characters or fewer',
  },
  errorFeedbackLength: {
    id: 'pages.cusat.errorFeedbackLength',
    defaultMessage: 'Feedback must be {max} characters or fewer',
  },
  export: {
    id: 'pages.cusat.export',
    defaultMessage: 'Export',
  },
  import: {
    id: 'pages.cusat.import',
    defaultMessage: 'Import',
  },
  importHint: {
    id: 'pages.cusat.importHint',
    defaultMessage:
      'Upload an .xlsx file with the same columns as the export. Rows are matched by account name: existing accounts are updated, new ones are added.',
  },
  importSucceeded: {
    id: 'pages.cusat.importSucceeded',
    defaultMessage:
      'Import finished: {created, plural, one {# account added} other {# accounts added}}, {updated, plural, one {# account updated} other {# accounts updated}}',
  },
  importFailedTitle: {
    id: 'pages.cusat.importFailedTitle',
    defaultMessage: 'Import rejected',
  },
  importFailedRows: {
    id: 'pages.cusat.importFailedRows',
    defaultMessage:
      'Nothing was imported. Fix the rows below in the file and upload it again.',
  },
  importFailedHeaders: {
    id: 'pages.cusat.importFailedHeaders',
    defaultMessage:
      'The file does not have the expected columns. Export the current data to get a file with the right layout.',
  },
  importFailedFileType: {
    id: 'pages.cusat.importFailedFileType',
    defaultMessage: 'Only .xlsx files can be imported.',
  },
  importFailedTooManyRows: {
    id: 'pages.cusat.importFailedTooManyRows',
    defaultMessage:
      'The file has too many rows. Split it into files of at most 5000 accounts.',
  },
  importFailedGeneric: {
    id: 'pages.cusat.importFailedGeneric',
    defaultMessage: 'The file could not be imported.',
  },
  importRowError: {
    id: 'pages.cusat.importRowError',
    defaultMessage: 'Row {row}',
  },
  emptyStateTitle: {
    id: 'pages.cusat.emptyStateTitle',
    defaultMessage: 'No CuSat data yet',
  },
  emptyStateDescription: {
    id: 'pages.cusat.emptyStateDescription',
    defaultMessage: 'Add an account or import an .xlsx file to get started',
  },
});
